/**
 * Feature flag for space search
 */
export const FEATURE_FLAG_SEARCH_IN_SPACE_DEVELOPEMENT = 'search-in-space-alpha';
